import { upsertThemeGQLMutation } from '../../graphql/index.js';
export class ThemeClient {
    constructor(client) {
        this.client = client;
    }
    async upsert(variables, fields = 'basic', accessToken) {
        const result = await this.client.authorizedRequest({
            query: upsertThemeGQLMutation(fields),
            variables,
            customToken: accessToken,
        });
        return result.upsertTheme;
    }
}
//# sourceMappingURL=theme.client.js.map